import useGuidebookIntegrationAccess from 'hooks/guidebook/useGuidebookIntegrationAccess';
import useNotify from 'hooks/useNotify';
import { useTranslation } from 'react-i18next';
import { redirectToIntegrationAccessUrl } from 'utils/integrations/integrationAccessUrl';

const useGuidebookRedirect = () => {
  const { t } = useTranslation();
  const { notifyError } = useNotify();
  const { fetchAccessUrl, isFetching } = useGuidebookIntegrationAccess();

  const redirectToGuidebook = () =>
    redirectToIntegrationAccessUrl({
      fetchAccessUrl,
      onAccessError: () => notifyError(t('common.guidebookAccessError')),
    });

  return { redirectToGuidebook, isFetching };
};

export default useGuidebookRedirect;
